import React from "react";
import module from "./ForgotPasswordButton.module.css";
import { Button } from "@mui/material";
import { Link } from "react-router-dom";

const ForgotPasswordButton = () => {
  return (
    <div className={module.forgotPassword}>
      <Button
        color="secondary"
        sx={{ fontSize: "0.8rem" }}
        LinkComponent={Link}
        to={"/forgot/pass"}
      >
        パスワードをお忘れの方 {">"}
      </Button>
    </div>
  );
};

export default ForgotPasswordButton;
